var map = {
	"./events_conflict_black.svg": "c1bc",
	"./events_crime_black.svg": "3506",
	"./events_disasters_black.svg": "9129",
	"./events_elections_black.svg": "8551",
	"./events_health_black.svg": "fc5a",
	"./events_insult_black.svg": "f951",
	"./events_political_terrorism_black.svg": "53ea",
	"./events_terrorism_black.svg": "3f2a",
	"./events_threat_black.svg": "dc67",
	"./events_toc_black.svg": "27d1",
	"./events_transportation_black.svg": "1675",
	"./events_travel_black.svg": "ca5a",
	"./events_unrest_black.svg": "0b38",
	"./events_war_black.svg": "a0dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ec1";